import { assertString, toDate } from '@/libs/utils'
import { now } from '@/utils/date-util'
import { defineRule } from '../define-rule'
import type { BaseRuleConstructorParams } from '../ts/rule-constructor-parameter.type'
import type { ManipulateType } from 'dayjs'

export type DateMaxAgeRuleConstructorParams = BaseRuleConstructorParams<{
  max: number
  dateFormat?: string
  unit?: ManipulateType
}>

export const dateMaxAge = defineRule(
  'date_max_age',
  ({ config, errorMessage }: DateMaxAgeRuleConstructorParams) => {
    const { max, dateFormat = 'DD.MM.YYYY', unit = 'years' } = config
    const error = errorMessage ?? false
    return (value: string) => {
      try {
        assertString(value)
        const day = toDate(value, dateFormat)
        const maxDay = toDate(
          now()
            .subtract(max ?? 0, unit)
            .format(dateFormat),
          dateFormat
        )
        // Found no other solution to add the isSameOrAfter plugin in typescript rule check
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (day as any).isSameOrAfter(maxDay) || error
      } catch {
        return error
      }
    }
  }
)
